import ProductTypeFactory from '../domain/services/ProductTypeFactory'
import { HTTP } from '../services/http'

const URL_GET_PRODUCT_TYPES = 'api/product-types'

export function getProductTypesApi () {
  return HTTP.get(URL_GET_PRODUCT_TYPES)
    .then(response => response.data.collection.map(productType => ProductTypeFactory.get(productType)))
}
